import { gql } from '@apollo/client';
export const ToggleFeatures = gql `
    mutation ToggleFeatures($institutionId: InstitutionId!, $features: [FeatureState!]!) {
        institutions {
            managedFeatures {
                setFeatures(institutionId: $institutionId, features: $features) {
                    enabled
                    featureId
                }
            }
        }
    }
`;
